/**
 * Frame quality shared by draw code.
 * 'high' keeps glow and canvas shadows. 'medium' and 'low' skip them —
 * shadowBlur forces an offscreen blur per draw and is the main mobile cost.
 */
let level = 'high';

export function renderQuality() {
    return level;
}

export function setRenderQuality(next) {
    level = next || 'high';
}

/**
 * When shadows are disallowed, ignore writes to ctx.shadowBlur so every
 * existing draw path stays cheap without editing each one.
 * Returns false if the context refused the override.
 */
export function applyCanvasShadowPolicy(ctx, allowShadow) {
    if (!ctx) return false;
    if (allowShadow) {
        if (ctx.__shadowLocked) {
            try { delete ctx.shadowBlur; } catch { /* host object */ }
            ctx.__shadowLocked = false;
        }
        return true;
    }
    if (ctx.__shadowLocked) return true;
    if (ctx.__shadowLockFailed) return false;
    try {
        ctx.shadowBlur = 0;
        Object.defineProperty(ctx, 'shadowBlur', {
            configurable: true,
            enumerable: true,
            get() { return 0; },
            set() { /* dropped on medium/low */ },
        });
        ctx.__shadowLocked = true;
        return true;
    } catch {
        ctx.__shadowLockFailed = true;
        ctx.shadowBlur = 0;
        return false;
    }
}
